<script>
import UserResource from '@/resources/user'
import CalendarResource from '@/resources/calendar'
import stripe, { elements } from '@/stripe'
import messages from '@/mixins/messages'
import { moneyFormatFromPositiveInteger } from '@/util'

export default {
    name: 'CostBreakdown',
    components: {},
    mixins: [messages],
    computed: {
        hasPaymentMethod() {
            return Object.keys(this.userCardInfo).length > 0
        }
    },
    data() {
        return {
            loading: true,
            costBreakdown: {
                total: 0,
                items: []
            },
        }
    },
    watch: {
        loading() {
            this.$emit('loading', this.loading)
        }
    },
    props: {
        userResource: {
            type: Object,
            required: true
        },
    },
    methods: {
        moneyFormatFromPositiveInteger,
    },
    async mounted() {
        this.loading = true
        this.costBreakdown = await this.userResource.getCost()
        this.userCardInfo = await this.userResource.getCard()
        this.loading = false
    },
    beforeDestroy() {
        if(this.elem) {
            this.elem.destroy()
        }
    }
}
</script>

<template>
    <div>
        <div v-if="messages.length > 0">
            <b-alert :variant="message.variant" show v-for="(message, i) in messages" :key="i">{{ message.text }}</b-alert>
        </div>

        <div v-if="loading" class="text-center">
            Cargando...
        </div>

        <div v-else>
            <table class="table subscription-table" v-if="Object.keys(this.costBreakdown).length > 0 && this.costBreakdown.total !== 0">
                <thead class="thead-dark">
                    <tr>
                        <th>Suscripción</th>
                        <th>Reservas</th>
                        <th class="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in costBreakdown.items" :key="i">
                        <td>{{ item.description }}</td>
                        <td>{{ item.qty }} x {{ currencySymbol() }}{{ moneyFormatFromPositiveInteger(item.amount_each) }}</td>
                        <td class="text-right">{{ currencySymbol() }}{{ moneyFormatFromPositiveInteger(item.amount) }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="text-right">Costo Mensual:</td>
                        <td class="text-right">{{ currencySymbol() }}{{ moneyFormatFromPositiveInteger(costBreakdown.total) }}</td>
                    </tr>
                </tbody>
            </table>

            <div v-else>
                <slot name="no-plan">
                    <h4>Plan Actual</h4>
                    <p>No estás siendo cobrado</p>
                </slot>
            </div>

            <slot name="add-new-button">
                <b-button variant="primary" :disabled="!hasPaymentMethod" :to="{ name: 'addSubscription' }">Agregar una Nueva Suscripción</b-button>
                <b-alert :show="!hasPaymentMethod" variant="warning" class="mt-2">
                    Agrega un método de pago para agregar una nueva suscripción
                </b-alert>
            </slot>

        </div>
    </div>
</template>

<style lang="scss" scoped>
.subscription-table {
    font-size: 80%;
}
</style>
